// extracted by mini-css-extract-plugin
export default {"Wrapper":"WhiteLabelsConfig_Wrapper__HwXia","ChangeLog":"WhiteLabelsConfig_ChangeLog__UAbQx"};